"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));

var _apiHelpers = require("./apiHelpers");

var _storage = require("../util/storage");

var _logRocketCookieUtils = require("../util/logrocket/logRocketCookieUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Method = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  patch: 'PATCH',
  delete: 'DELETE'
};
var CSRF_TOKEN_HEADER = 'x-csrf-token';
var CSRF_TOKEN_COOKIE = 'CSRF-TOKEN';
var LOG_ROCKET_HEADER = 'x-record-request-body'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var request = function request(url, options) {
  return (0, _isomorphicFetch.default)(url, options).then(_apiHelpers.handlePromise).then(_apiHelpers.handleErrors);
};

var get = function get(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var finalHeaders = _objectSpread(_objectSpread({
    'Content-Type': _apiHelpers.CONTENT_TYPE_JSON
  }, (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);

  var finalOptions = _objectSpread({
    method: Method.get,
    credentials: 'same-origin',
    headers: finalHeaders
  }, options);

  return request(url, finalOptions);
};

var post = function post(url, body) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var combinedHeaders = _objectSpread(_objectSpread(_defineProperty({
    'Content-Type': body instanceof FormData ? _apiHelpers.CONTENT_TYPE_MULTIPART_FORM : _apiHelpers.CONTENT_TYPE_JSON
  }, CSRF_TOKEN_HEADER, (0, _storage.getCookie)(CSRF_TOKEN_COOKIE)), (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);

  var finalHeaders = (0, _pickBy2.default)(combinedHeaders, function (value) {
    return value !== undefined;
  });
  var finalBody = finalHeaders['Content-Type'] === _apiHelpers.CONTENT_TYPE_JSON ? JSON.stringify(body) : body;

  var finalOptions = _objectSpread({
    method: Method.post,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders
  }, options);

  return request(url, finalOptions);
};

var put = function put(url, body) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var finalHeaders = _objectSpread(_objectSpread(_defineProperty({
    'Content-Type': _apiHelpers.CONTENT_TYPE_JSON
  }, CSRF_TOKEN_HEADER, (0, _storage.getCookie)(CSRF_TOKEN_COOKIE)), (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);

  var finalBody = JSON.stringify(body);

  var finalOptions = _objectSpread({
    method: Method.put,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders
  }, options);

  return request(url, finalOptions);
};

var patch = function patch(url, body) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var finalHeaders = _objectSpread(_objectSpread(_defineProperty({
    'Content-Type': _apiHelpers.CONTENT_TYPE_JSON
  }, CSRF_TOKEN_HEADER, (0, _storage.getCookie)(CSRF_TOKEN_COOKIE)), (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);

  var finalBody = JSON.stringify(body);

  var finalOptions = _objectSpread({
    method: Method.patch,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders
  }, options);

  return request(url, finalOptions);
};

var deleteMethod = function deleteMethod(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var finalHeaders = _objectSpread(_objectSpread(_defineProperty({
    'Content-Type': _apiHelpers.CONTENT_TYPE_JSON
  }, CSRF_TOKEN_HEADER, (0, _storage.getCookie)(CSRF_TOKEN_COOKIE)), (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);

  var finalOptions = _objectSpread({
    method: Method.delete,
    credentials: 'same-origin',
    headers: finalHeaders
  }, options);

  return request(url, finalOptions);
};

var _default = {
  request: request,
  get: get,
  post: post,
  put: put,
  patch: patch,
  delete: deleteMethod
};
exports.default = _default;